<template>
  <div class="mx-3">
    <div class="mb-2">
      <v-layout row wrap class="ma-0 pa-0" justify-space-between>
        <v-flex>
          <h1 style="color: black">Agent : {{ agentId }}</h1>
        </v-flex>
        <v-flex>
          <v-layout row nowrap justify-end>
            <v-btn color="primary" outline @click="showSearch = true"
              ><v-icon small>&nbsp;search&nbsp;</v-icon> {{ $t('Search') }}</v-btn
            >
            <exportxlsx :promised-value="getXlsxData"></exportxlsx>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-data-table
        :headers="headers"
        :items="rawData"
        class="elevation-1"
        :loading="loading"
        hide-actions
      >
        <template #items="props">
          <td>
            <v-avatar size="48">
              <v-img
                :lazy-src="props.item.customer_profile_pic"
                :src="
                  props.item.customer_profile_pic
                    ? props.item.customer_profile_pic
                    : '/static/img/assets/livechat/profile.png'
                "
                aspect-ratio="1"
                class="grey lighten-2"
              >
                <template #placeholder>
                  <v-layout fill-height align-center justify-center ma-0>
                    <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                  </v-layout>
                </template>
              </v-img>
            </v-avatar>
          </td>
          <td>{{ props.item.customer_name }}</td>
          <td>{{ props.item.submit_timestamp | DateFormat('DD/MM/YYYY HH:mm') }}</td>
          <td>
            {{ props.item && props.item.ticket_id ? props.item.ticket_id : '-' }}
          </td>
          <td>
            {{
              props.item && props.item.survey_data && props.item.survey_data[1]
                ? props.item.survey_data[1]
                : '-'
            }}
          </td>
          <td>
            {{
              props.item && props.item.survey_data && props.item.survey_data[2]
                ? props.item.survey_data[2]
                : '-'
            }}
          </td>
          <td>
            {{
              props.item && props.item.survey_data && props.item.survey_data[3]
                ? props.item.survey_data[3]
                : '-'
            }}
          </td>
        </template>
      </v-data-table>
      <v-layout row wrap justify-end class="mt-3">
        <v-pagination
          v-model="pageNumber"
          :length="pageCount"
          @input="handleChangePage"
        ></v-pagination>
      </v-layout>
    </div>
    <v-dialog
      v-model="showSearch"
      scrollable
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <div class="text-xs-right">
          <v-btn fab small flat @click="showSearch = false">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <v-layout wrap class="form-control">
            <v-flex xs12 sm6 class="pa-1">
              <div class="caption">Socail Name</div>
              <input v-model="filter.social_name" type="text" placeholder="Socail Name" />
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <div class="caption">Ticket no.</div>
              <input v-model="filter.ticket_id" type="text" placeholder="Ticket no." />
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <div class="caption">Start date</div>
              <datepicker v-model="filter.selectedDate.start" style></datepicker>
            </v-flex>
            <v-flex xs12 sm6 class="pa-1">
              <div class="caption">End date</div>
              <datepicker v-model="filter.selectedDate.end" style></datepicker>
            </v-flex>
          </v-layout>
          <v-layout row wrap justify-center>
            <v-btn outline color="grey" @click="handleClearSearch">{{ $t('Clear Search') }}</v-btn>
            <v-btn depressed color="primary" @click="handleSearch">
              <em class="fas fa-search mr-1" />
              {{ $t('Search') }}
            </v-btn>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import ticketApi from '@/api/ticket'
import { handleApiError } from '@/api/util'
import datepicker from 'vuejs-datepicker'

const baseFilter = {
  social_name: '',
  ticket_id: '',
  selectedDate: {
    end: dayjs().format('YYYY-MM-DD'),
    start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
  }
}

export default {
  components: { exportxlsx, datepicker },
  props: ['agentId'],
  data() {
    return {
      pageNumber: 1,
      rowPerPage: 10,
      total: 0,
      channelFilter: 'all',
      rawData: [],
      filter: { ...baseFilter },
      headers: [
        { text: '', sortable: false },
        { text: 'Socail Name', sortable: false },
        { text: 'วันและเวลา', sortable: false },
        { text: 'Ticket no.', sortable: false },
        { text: 'คำถามที่ 1', sortable: false },
        { text: 'คำถามที่ 2', sortable: false },
        { text: 'คำถามที่ 3', sortable: false }
      ],
      showSearch: false,
      isExport: false,
      loading: false,
      showDetailAgent: null
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pageCount() {
      return Math.ceil(this.total / this.rowPerPage)
    },
    offset() {
      return this.pageNumber * this.rowPerPage - this.rowPerPage
    }
  },
  mounted() {
    this.getSatisfactionSurveyAgent()
  },
  methods: {
    clearSearchSomeKey(key) {
      this.filter[key] = ''
      this.getSatisfactionSurveyAgent()
    },
    handleClearSearch() {
      this.filter = { ...baseFilter }
      this.filter.selectedDate = {
        end: dayjs().format('YYYY-MM-DD'),
        start: dayjs().subtract(7, 'days').format('YYYY-MM-DD')
      }
      this.pageNumber = 1
      this.showSearch = false
      this.getSatisfactionSurveyAgent()
    },
    handleSearch() {
      this.showSearch = false
      this.getSatisfactionSurveyAgent()
    },
    async getSatisfactionSurveyAgent() {
      try {
        this.loading = true
        await this.fetchSatisfactionSurveyAgent()
      } catch (error) {
        handleApiError(error)
      } finally {
        this.loading = false
      }
    },
    async handleChangePage(page) {
      this.pageNumber = page
      this.getSatisfactionSurveyAgent()
    },
    handleShowInAgent(adminId) {
      this.showDetailAgent = adminId
    },
    setSatisfactionSurveyData(returnData) {
      const total = returnData.total
      const data = returnData.data
      this.total = total
      this.rawData = data
    },
    async fetchSatisfactionSurveyAgent(
      setData = true,
      overWriteLimit = null,
      overWriteOffset = null
    ) {
      try {
        const params = {
          page_id: this.selectedBot.pageid,
          agent: this.agentId,
          limit: overWriteLimit ? overWriteLimit : this.rowPerPage,
          offset: overWriteOffset ? overWriteOffset : this.offset,
          date_from: this.filter.selectedDate.start
            ? dayjs(this.filter.selectedDate.start).format('YYYY-MM-DD')
            : null,
          date_to: this.filter.selectedDate.end
            ? dayjs(this.filter.selectedDate.end).format('YYYY-MM-DD')
            : null,
          social_name: this.filter.social_name,
          ticket_id: this.filter.ticket_id
        }
        const responseData = await ticketApi.getSatisfactionSurveyAgent(params)
        setData && this.setSatisfactionSurveyData(responseData.data)
        return responseData.data
      } catch (error) {
        handleApiError(error)
      }
    },
    getXlsxData() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve) => {
        this.isExport = true
        const responseData = await this.fetchSatisfactionSurveyAgent(false, 99999, 0)
        resolve(
          responseData.data.map((data) => {
            return {
              'Socail Name': data.customer_name,
              วันและเวลา: data.submit_timestamp
                ? dayjs(data.submit_timestamp).format('DD/MM/YYYY HH:mm')
                : '-',
              'Ticket no.': data && data.ticket_id ? data.ticket_id : '-',
              'คำถามที่ 1':
                data && data.survey_data && data.survey_data[1] ? data.survey_data[1] : '-',
              'คำถามที่ 2':
                data && data.survey_data && data.survey_data[2] ? data.survey_data[2] : '-',
              'คำถามที่ 3':
                data && data.survey_data && data.survey_data[3] ? data.survey_data[3] : '-'
            }
          })
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/juzmatch/AdminSatisfactionSurveyByAgent.vue